module.exports = __webpack_public_path__ + "img/HammockStandsAccessories.2387e33f.png";